import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/http-api';
import { Schema } from 'effect';
import { UserAuthMiddleware } from './middleware';
import { InternalServerError } from './errors';

export const AudioChanged = Schema.TaggedStruct('AudioChanged', {
  audioIds: Schema.NonEmptyArray(Schema.String),
});
/** Only listening progress moved: lists show it, the document is unchanged. */
export const ProgressChanged = Schema.TaggedStruct('ProgressChanged', {
  audioId: Schema.String,
});
export const Resync = Schema.TaggedStruct('Resync', {});
export const KeepAlive = Schema.TaggedStruct('KeepAlive', {});
/**
 * First event of every stream, sent once changes published from then on will
 * reach it. `allWriters` is false when only writes made by this API process
 * arrive (local dev without Valkey), so clients keep polling.
 */
export const Connected = Schema.TaggedStruct('Connected', {
  allWriters: Schema.Boolean,
});

export const ChangeEvent = Schema.Union([
  AudioChanged,
  ProgressChanged,
  Resync,
]);
export type ChangeEvent = typeof ChangeEvent.Type;

export const LiveEvent = Schema.Union([
  Connected,
  AudioChanged,
  ProgressChanged,
  Resync,
  KeepAlive,
]);
export type LiveEvent = typeof LiveEvent.Type;

const streamEventsEndpoint = HttpApiEndpoint.get('StreamEvents', '/', {
  success: HttpApiSchema.WithHeaders(
    HttpApiSchema.StreamSse({ data: LiveEvent }),
    { 'x-accel-buffering': Schema.Literal('no') },
  ),
  error: InternalServerError,
})
  .middleware(UserAuthMiddleware)
  .annotate(OpenApi.Summary, 'Stream Events')
  .annotate(
    OpenApi.Description,
    "Server-Sent Events telling the signed-in user's clients which data changed. Events are hints: refetch through the regular endpoints. `Resync` means events may have been missed, so refetch everything.",
  );

export const eventsGroup = HttpApiGroup.make('Events')
  .add(streamEventsEndpoint)
  .prefix('/v2/events');
